// eslint-disable-next-line check-file/filename-blocklist
import { MobilePageTypes } from 'core/constant/analytics/MobilePageTypes';
import { PageTypes } from 'core/constant/analytics/PageTypes';
import { WebViewPageTypes } from 'core/constant/analytics/WebViewPageType';

export type ActivitiesPageTypes = PageTypes | MobilePageTypes | WebViewPageTypes;

export const ActivitiesCombinedPageTypes: Record<ActivitiesPageTypes, PageTypes> = {
    [PageTypes.Home]: PageTypes.Home,
    [MobilePageTypes.Home]: PageTypes.Home,
    [WebViewPageTypes.Home]: PageTypes.Home,

    [PageTypes.City]: PageTypes.City,
    [MobilePageTypes.City]: PageTypes.City,
    [WebViewPageTypes.City]: PageTypes.City,

    [PageTypes.Search]: PageTypes.Search,
    [MobilePageTypes.Search]: PageTypes.Search,
    [WebViewPageTypes.Search]: PageTypes.Search,

    [PageTypes.Details]: PageTypes.Details,
    [MobilePageTypes.Details]: PageTypes.Details,
    [WebViewPageTypes.Details]: PageTypes.Details,

    [PageTypes.Country]: PageTypes.Country,
    [MobilePageTypes.Country]: PageTypes.Country,
    [WebViewPageTypes.Country]: PageTypes.Country,

    [PageTypes.Region]: PageTypes.Region,
    [MobilePageTypes.Region]: PageTypes.Region,
    [WebViewPageTypes.Region]: PageTypes.Region,

    [PageTypes.Area]: PageTypes.Area,
    [MobilePageTypes.Area]: PageTypes.Area,
    [WebViewPageTypes.Area]: PageTypes.Area,

    /** Pages not implemented in this codebase */
    [PageTypes.BookingForm1]: PageTypes.BookingForm1,
    [MobilePageTypes.BookingForm1]: PageTypes.BookingForm1,
    [WebViewPageTypes.BookingForm1]: PageTypes.BookingForm1,

    [PageTypes.BookingForm2]: PageTypes.BookingForm2,
    [MobilePageTypes.BookingForm2]: PageTypes.BookingForm2,
    [WebViewPageTypes.BookingForm2]: PageTypes.BookingForm2,

    [PageTypes.ThankYou]: PageTypes.ThankYou,
    [MobilePageTypes.ThankYou]: PageTypes.ThankYou,
    [WebViewPageTypes.ThankYou]: PageTypes.ThankYou,

    /** Special Pages * */
    [PageTypes.Unknown]: PageTypes.Unknown,
    [PageTypes.Login]: PageTypes.Login,
    [MobilePageTypes.Login]: PageTypes.Login,
    [PageTypes.PageNotFound]: PageTypes.PageNotFound,
    [WebViewPageTypes.PageNotFound]: PageTypes.PageNotFound,
};

export const isHomePage = (pageTypeId: ActivitiesPageTypes) => ActivitiesCombinedPageTypes[pageTypeId] === PageTypes.Home;
export const isSearchPage = (pageTypeId: ActivitiesPageTypes) => ActivitiesCombinedPageTypes[pageTypeId] === PageTypes.Search;
export const isDetailPage = (pageTypeId: ActivitiesPageTypes) => ActivitiesCombinedPageTypes[pageTypeId] === PageTypes.Details;
export const isCityPage = (pageTypeId: ActivitiesPageTypes) => ActivitiesCombinedPageTypes[pageTypeId] === PageTypes.City;

export enum PageTypeNames {
    Home = 'Home',
    Search = 'Search',
    Details = 'Details',
    PageNotFound = 'PageNotFound',
    City = 'City',
    Country = 'Country',
    Area = 'Area',
    Region = 'Region',
    Unknown = 'Unknown',
}

export const getPageNameFromPageTypeId = (pageTypeId: ActivitiesPageTypes): PageTypeNames => {
    if (isHomePage(pageTypeId)) {
        return PageTypeNames.Home;
    }
    if (isSearchPage(pageTypeId)) {
        return PageTypeNames.Search;
    }
    if (isDetailPage(pageTypeId)) {
        return PageTypeNames.Details;
    }
    if (isCityPage(pageTypeId)) {
        return PageTypeNames.City;
    }
    return PageTypeNames.Unknown;
};
